<template>
  <div
    class="w-full text-center text-2xl font-bold"
    :style="{
      color: `#${primaryColor}`,
    }"
  >
    {{ config?.faq_title }}
  </div>

  <!-- eslint-disable vue/no-v-html -->
  <div
    class="w-full text-center pt-4"
    v-html="config?.faq_subtitle"
  />
  <!-- eslint-enable vue/no-v-html -->

  <div
    class="grid md:gap-x-12 gap-y-8 w-full py-8 px-4"
    :class="gridColsClass"
  >
    <div
      v-for="(faqItem, index) in config?.faq_items ?? []"
      :key="index"
      class="rounded-md"
      :style="{
        'box-shadow': `4px 4px 12px #00000040`
      }"
    >
      <div class="p-6">
        <div
          class="w-full text-xl font-bold"
          :style="{
            color: `#${primaryColor}`,
          }"
        >
          {{ faqItem.question }}
        </div>

        <!-- eslint-disable vue/no-v-html -->
        <div
          class="pt-1"
          v-html="faqItem.answer"
        />
        <!-- eslint-enable vue/no-v-html -->
      </div>
    </div>
  </div>

  <SmallDivider
    :primary-color="primaryColor"
    :secondary-color="secondaryColor"
  />

  <!-- eslint-disable vue/no-v-html -->
  <div
    class="w-full text-center text-sm pt-2"
    v-html="config?.faq_footer"
  />
  <!-- eslint-enable vue/no-v-html -->
</template>

<script setup>
import {ref} from 'vue';
import SmallDivider from '@timon/js/Templates/PRE-LANDER-001/Components/SmallDivider.vue';

const props = defineProps({
  config: {
    type: Object,
    required: true,
  },

  primaryColor: {
    type: String,
    required: true,
  },

  secondaryColor: {
    type: String,
    required: true,
  },
});

const gridColsClass = ref([
  'grid-cols-1',
  'grid-cols-1 md:grid-cols-2',
  'grid-cols-1 md:grid-cols-3',
  'grid-cols-1 md:grid-cols-4',
][props.config?.faq_columns - 1] ?? 'grid-cols-1 md:grid-cols-3');
</script>
